module.exports = __webpack_public_path__ + "static/media/8OLA1.b8265883.jpg";